import React, {useEffect} from "react";
import {OrderedListOutlined, BorderOutlined, CheckSquareOutlined} from "@ant-design/icons";
import {Button, Form, Input, Modal, Table} from "antd";
import {useModel} from "../../../models";

const OPT_TYPE = {
    ADD: 1,
    REMOVE: 2
}
export default function () {
    const [form] = Form.useForm();

    const [
        {
            stockItemSelectModelVisible,
            stockItemList,
            stockItemPage,
            selectedStockItemList,
            checkDetailList,
            check
        },
        {
            setStockItemSelectModelVisible,
            loadStockItem,
            transSelectedStockItemListToStockItemList,
            setSelectedStockItemList,
            addToSelectedStockItemList,
            removeFromSelectedStockItemList,
        }
    ] = useModel("stockCheck");
    const {pageSize, pageNum} = stockItemPage;
    useEffect(() => {
        /*const {warehouseId, shelvesId} = check;
        const {pageNum, pageSize} = stockItemPage;
        loadStockItem({showMsg: false, data: {warehouseId, shelvesId, pageNum, pageSize}});*/
    }, []);

    const onOk = async () => {
        transSelectedStockItemListToStockItemList();
        //清空选中库存列表
        setSelectedStockItemList([]);
        //关闭库存选择窗口
        setStockItemSelectModelVisible(false);
    };

    const onClose = () => {
        setStockItemSelectModelVisible(false);
    };

    const onSearch = () => {

        const {warehouseId, shelvesId} = check;
        loadStockItem({showMsg: false, data: {pageSize, pageNum, warehouseId, shelvesId, ...form.getFieldsValue()}});
    };

    const onAdd = (record) => {
        addToSelectedStockItemList(record);
    };

    const onRemove = (record) => {
        removeFromSelectedStockItemList(record);
    };

    const Title = () => {
        return (

            <h3 style={{flex: "1"}}>
                <OrderedListOutlined/>
                <span className="margin-left-8">选择配件</span>
            </h3>

        )
    };
    const columns = (optType) => [
        {
            title: '',
            width: 40,
            render: (_, __, index) => index + 1,
        },
        {
            title: '商品编号',
            width: 140,
            dataIndex: 'materialCode',
            align: 'left',
        },
        {
            title: '商品名称',
            width: 280,
            dataIndex: 'materialName',
        },
        {
            title: '单位',
            width: 80,
            dataIndex: 'materialUnitName',
        },
        /*{
            title: '货架',
            dataIndex: 'shelvesCode',
        },*/
        {
            title: '货位',
            width: 140,
            dataIndex: 'shelfCode',
        },
        {
            title: '库存',
            width: 140,
            dataIndex: 'inventoryNum',
        },
        {
            title: '操作',
            width: 60,
            fixed: 'right',
            render: (text, record) => (
                optType === OPT_TYPE.ADD ? (<Button
                    type="link"
                    htmlType="button"
                    className="margin-left-8"
                    size="small"
                    disabled={
                        !!selectedStockItemList.find(el => el.key === record.key)
                        || !!checkDetailList.find(el => el.key === record.key)
                    }
                    onClick={() => onAdd(record)}
                >
                    添加
                </Button>) : (<Button
                    type="link"
                    htmlType="button"
                    className="margin-left-8"
                    size="small"
                    onClick={() => onRemove(record)}
                >
                    移除
                </Button>)),
        },
    ];
    const StockSearchForm = () => {
        return (
            <Form form={form} name="stock_search_form" layout="inline" onFinish={onSearch}>
                <Form.Item
                    name="codeOrName"
                >
                    <Input
                        placeholder="请输入商品编号或商品名称"
                        style={{width: "150px"}}
                    />
                </Form.Item>
                <Form.Item shouldUpdate={true}>
                    <Button htmlType="submit" type="primary">查询</Button>
                </Form.Item>
            </Form>
        )
    }
    const StockMaterialList = () => {
        return (
            <>
                <div style={{margin: "0 0 8px", display: "flex"}}>
                    <h3 style={{width: "700px", paddingTop: "6px"}}>
                        <BorderOutlined/> 待选配件列表
                    </h3>
                    <div className="detail-list-statistic">
                        <StockSearchForm/>
                    </div>
                </div>
                <Table
                    columns={columns(OPT_TYPE.ADD)}
                    dataSource={stockItemList}
                    bordered
                    pagination={{
                        hideOnSinglePage: false,
                        showQuickJumper: true,
                        defaultCurrent: 1,
                        defaultPageSize: pageSize,
                        onChange: (pageNum, pageSize) => {

                            loadStockItem({
                                showMsg: false,
                                data: {
                                    pageSize,
                                    pageNum,
                                    ...form.getFieldsValue()
                                }
                            });
                        },
                        total: stockItemPage.total,
                        current: stockItemPage.pageNum,
                    }}
                    scroll={{y: 220, x: 1300}}
                />
            </>
        )
    }
    const SelectedStockMaterialList = () => {
        return (
            <>
                <div style={{margin: "8px 0", display: "flex"}}>
                    <h3 style={{width: "460px", paddingTop: "6px"}}>
                        <CheckSquareOutlined/> 已选配件列表
                    </h3>
                    <div className="detail-list-statistic" style={{textAlign: "right"}}>

                    </div>
                </div>
                <Table
                    scroll={{y: 200, scrollToFirstRowOnChange: true}}
                    columns={columns(OPT_TYPE.REMOVE)}
                    dataSource={selectedStockItemList}
                    bordered
                    pagination={false}
                />
            </>
        )
    }
    return (
        <Modal
            title={<Title/>}
            width={1024}
            visible={stockItemSelectModelVisible}
            onOk={onOk}
            onCancel={onClose}
        >
            <StockMaterialList/>
            <SelectedStockMaterialList/>
        </Modal>
    );
}